import { MutationTree } from 'vuex'
import { state, UserState } from './state'
import { UserMutationTypes } from './mutation-types'
import { RouteRecordRaw } from 'vue-router'
import { store } from '../app'
import { setRoutes } from '@/utils/cookies'
import Layout from '@/layout/Index.vue'
import { useRouter, useRoute } from 'vue-router'
import router from '@/router'


export type Mutations<S = UserState> = {
    [UserMutationTypes.SET_USERINFO](state: S, userInfo: object): void
    [UserMutationTypes.SET_SHOPRULEDATA](state: S, shopRuleData: object): void 
    [UserMutationTypes.SET_EXPRESSMSG](state: S, expressMsg: object): void
    [UserMutationTypes.SET_SHOPRULEDATA](state: S, shopRuleData: object): void
    [UserMutationTypes.SET_PROMOTIONMSG](state: S, promotionMsg: object): void
    [UserMutationTypes.SET_STALEDATEMSG](state: S, staleDatedMsg: object): void
    [UserMutationTypes.SET_OBLIGATIONMSG](state: S, obligationMsg: object): void
    [UserMutationTypes.SET_RECONCLIATIONMSG](state: S, reconciliationMsg: object): void

    [UserMutationTypes.SET_CATROLE](state: S, catRole: object): void

    [UserMutationTypes.SET_STOCKMSG](state: S, StockMsg: object): void
    [UserMutationTypes.SET_CURRROUTE](state: S, currRoute: object): void
    [UserMutationTypes.ADD_INCLUDE](state: S, componentName: string): void
    [UserMutationTypes.DEL_INCLUDE](state: S, componentName: string): void
    [UserMutationTypes.SET_MENU_WARNING](state: S, warningData: object): void
    [UserMutationTypes.ADD_MENU_WARNING_ITEM](state: S, menuBadgeName: string, num: number): void
    [UserMutationTypes.MINUS_MENU_WARNING_ITEM](state: S, menuBadgeName: string, num: number): void
    [UserMutationTypes.SET_IS_CONTRACTS](state: S, is_contracts: number): void
}

export const mutations = {
    [UserMutationTypes.SET_USERINFO](state, userInfo) {
        state.userInfo = userInfo
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    [UserMutationTypes.SET_SHOPRULEDATA](state, shopRuleData) {
        state.shopRuleData = shopRuleData
        localStorage.setItem('shopRuleData', JSON.stringify(shopRuleData))
    },
    [UserMutationTypes.SET_EXPRESSMSG](state, expressMsg) {
        state.expressMsg = expressMsg
        localStorage.setItem('expressMsg', JSON.stringify(expressMsg))
    },
    [UserMutationTypes.SET_PROMOTIONMSG](state, promotionMsg) {
        state.promotionMsg = promotionMsg
        localStorage.setItem('promotionMsg', JSON.stringify(promotionMsg))
    },
    [UserMutationTypes.SET_STALEDATEMSG](state, staleDatedMsg) {
        state.staleDatedMsg = staleDatedMsg
        localStorage.setItem('staleDatedMsg', staleDatedMsg)
    },
    [UserMutationTypes.SET_OBLIGATIONMSG](state, ratingMsg) {
        state.ratingMsg = ratingMsg
        localStorage.setItem('ratingMsg', ratingMsg)
    },
    [UserMutationTypes.SET_RECONCLIATIONMSG](state, reconciliationMsg) {
        state.reconciliationMsg = reconciliationMsg
        localStorage.setItem('reconciliationMsg', reconciliationMsg)
    },
    [UserMutationTypes.SET_CATROLE](state, catRole) {
        state.catRole = catRole
        localStorage.setItem('catRole', catRole)
    },
    [UserMutationTypes.SET_STOCKMSG](state, StockMsg) {
        state.StockMsg = StockMsg
        localStorage.setItem('StockMsg', StockMsg)
    },
    [UserMutationTypes.SET_CURRROUTE](state, currRoute) {
        state.currRoute = currRoute
    },
    [UserMutationTypes.ADD_INCLUDE](state, componentName: string) {
        if (!state.aliveInclude.includes(componentName))
        state.aliveInclude.push(componentName)
    },
    [UserMutationTypes.DEL_INCLUDE](state, componentName: string) {
        const index = state.aliveInclude.indexOf(componentName)
        if (index !== -1) {
            state.aliveInclude.splice(index, 1)
        }
    },
    [UserMutationTypes.SET_MENU_WARNING](state, warningData: object) {
        state.menuWarning = warningData
    },
    [UserMutationTypes.ADD_MENU_WARNING_ITEM](state, menuBadgeName: string, num: number = 1) {
        if (state.menuWarning[menuBadgeName]) {
            state.menuWarning[menuBadgeName] += num
        }
    },
    [UserMutationTypes.MINUS_MENU_WARNING_ITEM](state, menuBadgeName: string, num: number = 1) {
        if (state.menuWarning[menuBadgeName]) {
            state.menuWarning[menuBadgeName] -= num
        }
    },
    [UserMutationTypes.SET_IS_CONTRACTS](state, is_contracts) {
        state.is_contracts = is_contracts
        localStorage.setItem('is_contracts', is_contracts)
    },
}
